// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dev-mode-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #ff6b6b;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  transition: background-color 0.2s, transform 0.1s;
  animation: pulse 2s infinite;
}

.dev-mode-button:hover {
  background-color: #ff5252;
  transform: translateY(-2px);
}

.dev-mode-button:active {
  transform: translateY(0);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 107, 107, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/atoms/devModeButton/devModeButton.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,wCAAwC;EACxC,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".dev-mode-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: #ff6b6b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  z-index: 9999;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n  transition: background-color 0.2s, transform 0.1s;\n  animation: pulse 2s infinite;\n}\n\n.dev-mode-button:hover {\n  background-color: #ff5252;\n  transform: translateY(-2px);\n}\n\n.dev-mode-button:active {\n  transform: translateY(0);\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(255, 107, 107, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(255, 107, 107, 0);\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
